import API from 'services/api';

interface IProps {
  id: string;
  statusTypeId: number;
  renterOptionDate: string | null | undefined;
}

export const updateReservationStatus = ({
  id,
  statusTypeId,
  renterOptionDate,
}: IProps): Promise<null> =>
  API.put(`api/accommodation/calculations/${id}/status/${statusTypeId}`, null, {
    params: { renterOptionDate },
  }).then(response => response?.data);
